/**
 * External dependencies
 */
import { useCallback } from "react";
import useSWRInfinite from "swr/infinite";

/**
 * Internal dependencies
 */
import { pageFetcher } from "./fetcher";
import { objectToUrlParams } from "../utils";

/**
 * Configuration
 */
import config from "../config";
const { ajax_url, actions } = config;

/**
 * @see https://swr.vercel.app/docs/pagination#example-2-cursor-or-offset-based-paginated-api
 */
export function useInfinitePosts(
	perPage,
	requestData,
	action = actions?.posts
) {
	const requestParams = objectToUrlParams(requestData);
	const lang =  document.documentElement.getAttribute('lang');

	const { data, error, size, setSize, isValidating } = useSWRInfinite(
		(index) => [ajax_url, action, perPage, index + 1, requestParams + '&lang=' + lang],
		pageFetcher
	);

	const posts = data ? [].concat(...data) : [];
	const isLoadingInitialData = !data && !error;
	const isLoadingMore =
		size > 0 && data && typeof data[size - 1] === "undefined";
	const isEmpty = data?.[0]?.length === 0;
	const isReachingEnd =
		isEmpty || (data && data[data.length - 1]?.length < perPage);
	const isRefreshing = isValidating && data && data.length === size;

	const loadMore = useCallback(() => {
		setSize(size + 1);
	}, [requestParams, size]);

	return {
		posts,
		error,
		size,
		loadMore,
		isLoadingInitialData,
		isLoadingMore,
		isReachingEnd,
		isRefreshing,
		isEmpty,
	};
}
